import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import NavBar from "../../structure/NavBar"
import ReplyIcon from '@mui/icons-material/Reply'
import { NavBarTop } from "../../structure/NavBarTop"
import { updateTopHeader, uplodateLoading } from "../../../redux/features/common/commonSlice"
import { useDispatch, useSelector } from "react-redux"
import urls from "../../constants/apiurl"
import ApiCaller from "../../constants/ApiCaller"
import { showDangerToast } from "../../constants/toaster"
import Utils from "../../constants/Utils"
import { formatIndianNumber } from "../../lib/formatIndianNumber"

export const View = (props) => {
    const { formatDate } = Utils();
    const userData = useSelector(state => state?.userData)
    const [recentUserVideos, setRecentUserVideos] = useState([])
    const [userDetailsData, setUserDetailsData] = useState({})
    const router = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()

    useEffect(() => {
        dispatch(updateTopHeader('User Manager'))
        if (id) {
            getUserDetails()
        }
    }, [id])


    const getUserDetails = async () => {
        try {
            dispatch(uplodateLoading(true))
            let path = urls.userDetails + '/' + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(uplodateLoading(false))
                console.log(response?.data)
                setUserDetailsData(response?.data)
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }


    return (
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                <div className='container-fluid mt--7'>
                    <div className='row'>
                        <div className='col-md-12 text-left'>
                            <a
                                onClick={() => router("/special-reward-manager")}
                                className='btn btn-sm btn-primary text-white'
                            >
                                <ReplyIcon />
                                Back
                            </a>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <p className='text-uppercase text-sm'>Special Reward Request Information</p>
                                    <div className='row'>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Username
                                            </label>
                                            <p>{userDetailsData?.userName}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                USER ID
                                            </label>
                                            <p>{userDetailsData?.chatUserId}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Full Name
                                            </label>
                                            <p>{userDetailsData?.fullName}</p>
                                        </div>
                                        <div className='col-md-3' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Email
                                            </label>
                                            <p>{userDetailsData?.email}</p>
                                        </div>
                                        <div className='col-md-3' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Mobile
                                            </label>
                                            <p>
                                                {userDetailsData?.ext} {userDetailsData?.contactNumber}
                                            </p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Gender
                                            </label>
                                            <p>{userDetailsData?.gender}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Date Of Birth
                                            </label>
                                            <p>{userDetailsData?.dob}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Date Of Registration
                                            </label>
                                            <p>{formatDate(userDetailsData?.createdAt)}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Exclusive Enable
                                            </label>
                                            <p>
                                                {userDetailsData?.exclusiveEnable ? (
                                                    <span className='label label-default'>Enabled</span>
                                                ) : (
                                                    <span className='label label-default'>Disabled</span>
                                                )}
                                            </p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Account Type
                                            </label>
                                            <p>{userDetailsData?.accountType}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Register Via
                                            </label>
                                            <p>{userDetailsData?.signInType}</p>
                                        </div>
                                        <div className='col-md-2' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Total Chips:
                                            </label>
                                            <p>{formatIndianNumber(userDetailsData?.totalChipsBalance)}</p>
                                        </div>
                                        <div className='col-md-10' style={{ textAlign: 'left' }}>
                                            <label
                                                htmlFor='example-text-input'
                                                className='form-control-label'
                                            >
                                                Category:
                                            </label>
                                            <p>{userDetailsData?.userPreferredTags?.join(",")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}